<template>
  <div class="content-milestones">
    <Timeline v-if="content.chart" :content="content.chart" />
  </div>
</template>

<script>
import Timeline from '@/components/content/charts/Timeline.vue';

export default {
  name: 'Milestones',
  components: {
    Timeline,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.content-milestones {
  padding: 60px 0;
  background-color: #fff;

  @media #{map-get($media-breakpoints, 'mobile')} {
      padding: 30px 15px;
  }
}
</style>
